import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const RestructureLoan = (props) => {
  const isAdmin = props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;
  var isReadonly = props.urlparams.params.readonly === "true" ? true : false;
  var tabStatus = props.urlparams.params.status;
  const productTypeParam = props.urlparams.params.producttype;
  var applStatus = props.urlparams.params.applicationStatus;
  const [sanctioneddocs, setSanctioneddocs] = useState([]);
  const [editdata, setEditdata] = useState(null);
  // ----------------------------------------------------------------

  const [oldloanfields, setOldloanfields] = useState([
    {
      name: "borrowerName",
      label: "Customer Name",
      type: "text",
      readOnly: true,
    },
    {
      name: "loanAccountNumber",
      label: "Loan Account No",
      type: "text",
      readOnly: true,
    },
    {
      name: "sanctionedLoanAmount",
      label: "Sanctioned Loan Amount",
      type: "text",
      readOnly: true,
    },
    {
      name: "sanctionedLoanTenure",
      label: "Tenure",
      type: "text",
      readOnly: true,
    },
    {
      name: "sanctionedLoanPF",
      label: "Processing Fees",
      type: "text",
      readOnly: true,
    },
    {
      name: "loanPaymentMode",
      label: "Repayment Type",
      type: "text",
      readOnly: true,
    },
    {
      name: "sanctionedLoanStartDate",
      label: "Loan Start Date",
      type: "date",
      readOnly: true,
    },
    {
      name: "sanctionedLoanEndDate",
      label: "Loan End Date",
      type: "date",
      readOnly: true,
    },
    {
      name: "totalAmountPayableAmtTillDate",
      label: "Total Amt Payable",
      type: "text",
      readOnly: true,
    },
    {
      name: "remarks",
      label: "Remarks",
      type: "textarea",
      readOnly: true,
      customcolspan: 12,
    },
  ]);

  const [restructurefields, setRestructurefields] = useState([
    {
      name: "loanAccountNumber",
      label: "Loan Account Number",
      type: "text",
      readOnly: true,
    },
    {
      name: "outstandingAmount",
      label: "Outstanding",
      type: "text",
      readOnly: true,
    },
    { name: "overdue", label: "Overdue", type: "text", readOnly: true },
    {
      name: "restructureWaiver",
      label: "Waiver",
      type: "text",
      readOnly: true,
    },
    {
      name: "sanctionedLoanAmt",
      label: "New Loan Amt",
      type: "text",
      readOnly: true,
    },
    { name: "restructureIRR", label: "ROI", type: "text", readOnly: true },
    {
      name: "restructureTenure",
      label: "Tenure",
      type: "text",
      readOnly: true,
    },
    {
      name: "restructureLoanStartDate",
      label: "New Loan Start Date",
      type: "date",
      required: true,
    },
    {
      name: "restructureLoanEndDate",
      label: "New Loan End Date",
      type: "date",
      required: true,
    },
    {
      name: "remarks",
      label: "Admin Remarks",
      type: "text",
      readOnly: true,
    },
    {
      name: "adminCustomRemarks",
      label: "Your Remarks",
      type: "text",
      required: true,
    },
  ]);

  const handleApproveRestructure = (e, data) => {
    e.preventDefault();
    let payload = {
      restructureLoanStartDate: new Date(
        data?.restructureLoanStartDate
      ).toISOString(),
      restructureLoanEndDate: new Date(
        data?.restructureLoanEndDate
      ).toISOString(),
      remarks: data?.adminCustomRemarks,
    };
    console.log({ payload });

    swal2
      .fire({
        title: "Are you sure want to approve this loan application ?",
        icon: "warning",
        iconColor: "#BB1766",
        showCancelButton: true,
        confirmButtonColor: "#BB1766",
        cancelButtonColor: "##D6DBE7",
        confirmButtonText: "Yes",
      })
      .then((result) => {
        if (result.isConfirmed) {
          props.apis
            .apiAdminLoanRestructureFinalApprove(payload, {
              loanAccountNumber: props.urlparams.params.lanid,
            })
            .then((res) => {
              console.log(res);
              if (res) {
                swal2.fire({
                  title: "Loan Approved Successfully",
                  icon: "success",
                  iconColor: "#BB1766",
                  showCancelButton: false,
                  timer: 3000,
                });

                navigate(
                  `/app/loandetails?activetab=${tabStatus}&producttype=${productTypeParam}`,
                  {
                    replace: true,
                  }
                );
              }
            });
        }
      });
  };

  const getLoanAccountDetails = () => {
    props.apis
      .apiUnderWriterLoanAccountById({
        applicationId: props.urlparams.params.id,
      })
      .then((res) => {
        if (res) {
          setEditdata(res);

          let updatedOldLoanDetails = oldloanfields?.map((field) => {
            return {
              ...field,
              defaultValue: res[field.name],
            };
          });
          setOldloanfields(updatedOldLoanDetails);

          if (res?.restructure) {
            let updatedRestructureLoanDetails = restructurefields?.map(
              (field) => {
                return {
                  ...field,
                  defaultValue: res?.restructure[field.name],
                };
              }
            );
            setRestructurefields(updatedRestructureLoanDetails);
          }
        }
      });
  };

  useEffect(() => {
    getLoanAccountDetails();
  }, []);
  props.$setNode({
    props,
  });
  return (
    <>
      <AppForm
        className="mx-auto justify-content-center"
        onSubmit={handleApproveRestructure}
      >
        <div className="row flex-row card p-4">
          <h2 class="mb-3 fs-4 text-primary">Old Loan Details</h2>
          {oldloanfields.map((field, i) => (
            <div
              className={`col-6 col-md-4 col-lg-${field?.customcolspan || 4}`}
              key={i}
            >
              <AppInput {...field}></AppInput>
            </div>
          ))}
        </div>
        <div className="row flex-row card p-4">
          <h2 class="mb-3 fs-4 text-primary">Restructure Loan Details</h2>
          {restructurefields.map((field, i) => (
            <div
              className={`col-6 col-md-4 col-lg-${field?.customcolspan || 4}`}
              key={i}
            >
              <AppInput {...field}></AppInput>
            </div>
          ))}
        </div>

        {isReadonly ? (
          <>
            <div className="nav_container">
              <Link
                to={`/app/loandetails?activetab=${tabStatus}&producttype=${productTypeParam}`}
                className="btn btn-primary"
              >
                Close
              </Link>
            </div>
          </>
        ) : (
          <div className="nav_container">
            <Link
              to={`/app/loandetails?activetab=${tabStatus}&producttype=${productTypeParam}`}
              className="btn btn-primary-lite me-3"
            >
              Cancel
            </Link>
            <button type="submit" className="btn btn-primary">
              Approve
            </button>
          </div>
        )}
      </AppForm>
    </>
  );
};

export default constore(RestructureLoan);
